module.exports = __webpack_public_path__ + "img/build2.5096e190.png";